import { SearchCriteria } from "./search-criteria";

export class PettyCashItemsSearchCriteria extends SearchCriteria {
    public Id: number;
}
